module.exports = __webpack_public_path__ + "img/right-angle.8414e75a.svg";